import { SVGProps, Ref, forwardRef } from 'react';

export const SmileFaceFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m-1.344 15.584c-.18-.191-.256-.393-.256-.584H8.6c0 .71.295 1.339.744 1.816.644.686 1.617 1.084 2.656 1.084s2.012-.398 2.656-1.084c.448-.477.744-1.106.744-1.816h-1.8c0 .19-.076.393-.256.584-.268.285-.747.516-1.344.516s-1.076-.23-1.344-.516M6.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75m8.75-1.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
            fill="currentColor"
        />
    </svg>
));
SmileFaceFilledSize24Glyph.displayName = 'SmileFaceFilledSize24Glyph';
